import React from "react";
import {
  AspectRatio,
  Badge,
  Box,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Section from "./Section";
import SEO from "./SEO";

const IntroVideo: React.FC = () => {
  const { t } = useTranslation();

  const videos = [
    { src: "https://www.youtube.com/embed/0IGXNHL9oLo", title: t("video.video84"), detail: t("video.detail84"), type: "youtube" },
    { src: "https://www.youtube.com/embed/AQIJ5TCKQYc", title: t("video.video83"), detail: t("video.detail83"), type: "youtube" },
    { src: "https://www.youtube.com/embed/-K1Dpcolm4c", title: t("video.video82"), detail: t("video.detail82"), type: "youtube" },
    { src: "https://www.youtube.com/embed/WG1nY940EuQ", title: t("video.video81"), detail: t("video.detail81"), type: "youtube" },
    { src: "https://www.youtube.com/embed/On-5uQJaDRc", title: t("video.video80"), detail: t("video.detail80"), type: "youtube" },
    { src: "https://www.youtube.com/embed/KA-Lb0pOawc", title: t("video.video79"), detail: t("video.detail79"), type: "youtube" },
    { src: "https://www.youtube.com/embed/56Bi8WGkeis", title: t("video.video78"), detail: t("video.detail78"), type: "youtube" },
    { src: "https://www.youtube.com/embed/Lf_F-0HY_No", title: t("video.video77"), detail: t("video.detail77"), type: "youtube" },
    { src: "https://www.youtube.com/embed/1pLlENFoG_g", title: t("video.video76"), detail: t("video.detail76"), type: "youtube" },
    { src: "https://www.youtube.com/embed/43Qu7J_6YbU", title: t("video.video75"), detail: t("video.detail75"), type: "youtube" },
    { src: "https://www.youtube.com/embed/SFiMkzv6V24", title: t("video.video74"), detail: t("video.detail74"), type: "youtube" },
    { src: "https://www.youtube.com/embed/e9Mq6KipLoE", title: t("video.video73"), detail: t("video.detail73"), type: "youtube" },
    { src: "https://www.youtube.com/embed/GUf_CUdFSb0", title: t("video.video72"), detail: t("video.detail72"), type: "youtube" },
    { src: "https://www.youtube.com/embed/VALQyPXBDlM", title: t("video.video71"), detail: t("video.detail71"), type: "youtube" },
    { src: "https://www.youtube.com/embed/x7tJrbIjo-Q", title: t("video.video70"), detail: t("video.detail70"), type: "youtube" },
    { src: "https://www.youtube.com/embed/5daSPfO_mCc", title: t("video.video69"), detail: t("video.detail69"), type: "youtube" },
    { src: "https://www.youtube.com/embed/BiN3iHWaJoA", title: t("video.video68"), detail: t("video.detail68"), type: "youtube" },
    { src: "https://www.youtube.com/embed/QsdJxghwCeY", title: t("video.video67"), detail: t("video.detail67"), type: "youtube" },
    { src: "https://www.youtube.com/embed/c0avON4NruE", title: t("video.video66"), detail: t("video.detail66"), type: "youtube" },
    { src: "https://www.youtube.com/embed/c1-HIdJS6NU", title: t("video.video65"), detail: t("video.detail65"), type: "youtube" },
    { src: "https://www.youtube.com/embed/zRTAeOcmPbQ", title: t("video.video64"), detail: t("video.detail64"), type: "youtube" },
    { src: "https://www.youtube.com/embed/hNSV-ztr6ZY", title: t("video.video63"), detail: t("video.detail63"), type: "youtube" },
    { src: "https://www.youtube.com/embed/qnSjxIOU5rM", title: t("video.video62"), detail: t("video.detail62"), type: "youtube" },
    { src: "https://www.youtube.com/embed/IscFKp69M3A", title: t("video.video61"), detail: t("video.detail61"), type: "youtube" },
    { src: "https://www.youtube.com/embed/u9JVIq8vh4g", title: t("video.video60"), detail: t("video.detail60"), type: "youtube" },
    { src: "https://www.youtube.com/embed/a36YeYnK58U", title: t("video.video59"), detail: t("video.detail59"), type: "youtube" },
    { src: "https://www.youtube.com/embed/iKj_UUggC7M", title: t("video.video58"), detail: t("video.detail58"), type: "youtube" },
    { src: "https://www.youtube.com/embed/Ugvan3y4JMQ", title: t("video.video57"), detail: t("video.detail57"), type: "youtube" },
    { src: "https://www.youtube.com/embed/LvhSoKHkue0", title: t("video.video56"), detail: t("video.detail56"), type: "youtube" },
    { src: "https://www.youtube.com/embed/bPIG52KUpfw", title: t("video.video55"), detail: t("video.detail55"), type: "youtube" },
    { src: "https://www.youtube.com/embed/KJuuyXSlQfs", title: t("video.video54"), detail: t("video.detail54"), type: "youtube" },
    { src: "https://www.youtube.com/embed/V94uq6Ugxtk", title: t("video.video53"), detail: t("video.detail53"), type: "youtube" },
    { src: "https://www.youtube.com/embed/le2pkt73h4Y", title: t("video.video52"), detail: t("video.detail52"), type: "youtube" },
    { src: "https://www.youtube.com/embed/sAbsVpQVT1M", title: t("video.video51"), detail: t("video.detail51"), type: "youtube" },
    { src: "https://www.youtube.com/embed/7qQ3KEnKdnw", title: t("video.video50"), detail: t("video.detail50"), type: "youtube" },
    { src: "https://www.youtube.com/embed/OpW602FSY_s", title: t("video.video49"), detail: t("video.detail49"), type: "youtube" },
    { src: "https://www.youtube.com/embed/8pWCuJwlYPc", title: t("video.video48"), detail: t("video.detail48"), type: "youtube" },
    { src: "https://www.youtube.com/embed/dOoyftEuAAk", title: t("video.video20"), detail: t("video.detail20"), type: "youtube" },
    { src: "https://www.youtube.com/embed/jHkhNOPoxhA", title: t("video.video46"), detail: t("video.detail46"), type: "youtube" },
    { src: "https://www.youtube.com/embed/IsgfeqLyWoM", title: t("video.video47"), detail: t("video.detail47"), type: "youtube" },
    { src: "https://www.youtube.com/embed/TrbfD2xDxaQ", title: t("video.video1"), detail: t("video.detail1"), type: "youtube" },
    { src: "https://www.youtube.com/embed/zxScw1rEMfQ", title: t("video.video2"), detail: t("video.detail2"), type: "youtube" },
    { src: "https://www.youtube.com/embed/4_WVTcLIfRg", title: t("video.video3"), detail: t("video.detail3"), type: "youtube" },
    { src: "https://www.youtube.com/embed/0qNtHieEy-Y", title: t("video.video4"), detail: t("video.detail4"), type: "youtube" },
    { src: "https://www.youtube.com/embed/zbS6-FKo0RQ", title: t("video.video5"), detail: t("video.detail5"), type: "youtube" },
    { src: "https://www.youtube.com/embed/JNgJZYl-7qE", title: t("video.video6"), detail: t("video.detail6"), type: "youtube" },
    { src: "https://www.youtube.com/embed/P3jB2Ul4ZF8", title: t("video.video7"), detail: t("video.detail7"), type: "youtube" },
    { src: "https://www.youtube.com/embed/JvZPiHHphKs", title: t("video.video8"), detail: t("video.detail8"), type: "youtube" },
    { src: "https://www.youtube.com/embed/udJ-3Gf_bVM", title: t("video.video9"), detail: t("video.detail9"), type: "youtube" },
    { src: "https://www.youtube.com/embed/ZxdTVL7aVSc", title: t("video.video10"), detail: t("video.detail10"), type: "youtube" },
    { src: "https://www.youtube.com/embed/lRP-xoa5EzY", title: t("video.video11"), detail: t("video.detail11"), type: "youtube" },
    { src: "https://www.youtube.com/embed/Q1uMGxDCAww", title: t("video.video12"), detail: t("video.detail12"), type: "youtube" },
    { src: "https://www.youtube.com/embed/WLzGy_-RvoM", title: t("video.video13"), detail: t("video.detail13"), type: "youtube" },
    { src: "https://www.youtube.com/embed/TTC2Rwuj--U", title: t("video.video14"), detail: t("video.detail14"), type: "youtube" },
    { src: "https://www.youtube.com/embed/mu3AnBP9Ynk", title: t("video.video15"), detail: t("video.detail15"), type: "youtube" },
    { src: "https://www.youtube.com/embed/MpZu6qwcreE", title: t("video.video16"), detail: t("video.detail16"), type: "youtube" },
    { src: "https://www.youtube.com/embed/Fx4XVsG1U0w", title: t("video.video17"), detail: t("video.detail17"), type: "youtube" },
    { src: "https://www.youtube.com/embed/SArHuxoiqqs", title: t("video.video18"), detail: t("video.detail18"), type: "youtube" },
    { src: "https://www.youtube.com/embed/JOomNiBMTLo", title: t("video.video19"), detail: t("video.detail19"), type: "youtube" },
    { src: "https://www.youtube.com/embed/5kamPUvZCxQ", title: t("video.video21"), detail: t("video.detail21"), type: "youtube" },
    { src: "https://www.youtube.com/embed/RmLBwtlJ92U", title: t("video.video23"), detail: t("video.detail23"), type: "youtube" },
    { src: "https://www.youtube.com/embed/cJOEKQKZQR0", title: t("video.video24"), detail: t("video.detail24"), type: "youtube" },
    { src: "https://www.youtube.com/embed/N55KvsaEEgM", title: t("video.video25"), detail: t("video.detail25"), type: "youtube" },
    { src: "https://www.youtube.com/embed/zvfm2itEMzk", title: t("video.video26"), detail: t("video.detail26"), type: "youtube" },
    { src: "https://www.youtube.com/embed/XDX6olV9Ps8", title: t("video.video27"), detail: t("video.detail27"), type: "youtube" },
    { src: "https://www.youtube.com/embed/o2FAxwHn23Y", title: t("video.video28"), detail: t("video.detail28"), type: "youtube" },
    { src: "https://www.youtube.com/embed/rNv0KTIP_e8", title: t("video.video29"), detail: t("video.detail29"), type: "youtube" },
    { src: "https://www.youtube.com/embed/aROvLtKD3XE", title: t("video.video30"), detail: t("video.detail30"), type: "youtube" },
    { src: "https://www.youtube.com/embed/MyKbRQ5Txho", title: t("video.video31"), detail: t("video.detail31"), type: "youtube" },
    { src: "https://www.youtube.com/embed/CCzcIT5zGkA", title: t("video.video32"), detail: t("video.detail32"), type: "youtube" },
    { src: "https://www.youtube.com/embed/DaIWpxR8u74", title: t("video.video33"), detail: t("video.detail33"), type: "youtube" },
    { src: "https://www.youtube.com/embed/Co8NxhDl5fc", title: t("video.video34"), detail: t("video.detail34"), type: "youtube" },
    { src: "https://www.youtube.com/embed/n4Fxp3I2PEc", title: t("video.video35"), detail: t("video.detail35"), type: "youtube" },
    { src: "https://www.youtube.com/embed/zioeZwcNrCk", title: t("video.video37"), detail: t("video.detail37"), type: "youtube" },
    { src: "https://www.youtube.com/embed/AjO8YtRyV1g", title: t("video.video38"), detail: t("video.detail38"), type: "youtube" },
    { src: "https://www.youtube.com/embed/ths5TOCtnUA", title: t("video.video39"), detail: t("video.detail39"), type: "youtube" },
    { src: "https://www.youtube.com/embed/q8_ERKRe1YA", title: t("video.video40"), detail: t("video.detail40"), type: "youtube" },
    { src: "https://www.youtube.com/embed/AuuOmfR3PGY", title: t("video.video41"), detail: t("video.detail41"), type: "youtube" },
    { src: "https://www.youtube.com/embed/GlErqHRWY6k", title: t("video.video42"), detail: t("video.detail42"), type: "youtube" },
    { src: "https://www.youtube.com/embed/DAGhx4U8pH8", title: t("video.video43"), detail: t("video.detail43"), type: "youtube" },
    { src: "https://www.youtube.com/embed/7p_03sZfvw4", title: t("video.video45"), detail: t("video.detail45"), type: "youtube" },
  ];

  const getVideoId = (url: string) => {
    const match = url.match(/embed\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : "";
  };

  const getPreviewText = (detail: string) => detail.replace(/\s+/g, " ").trim();

  const openVideo = (src: string) => {
    const autoplaySrc = src.includes("youtube")
      ? `${src}?autoplay=1&mute=0&controls=1&modestbranding=1`
      : src;
    window.open(autoplaySrc, "_blank");
  };

  return (
    <>
      <SEO
        title={t("seo.pages.video.title")}
        description={t("seo.pages.video.description")}
        keywords={t("seo.pages.video.keywords")}
        canonical="https://deepsoulai.com/introVideo"
      />
      <Section title={t("video.title")} maxW="1400px">
        <SimpleGrid
          columns={{ base: 1, sm: 2, lg: 3, xl: 4 }}
          spacing={{ base: 4, md: 5 }}
          px={{ base: 0, md: 2 }}
          py={{ base: 2, md: 4 }}
          alignItems="stretch"
        >
          {videos.map(({ src, title, detail, type }) => (
            <Card
              key={src}
              role="button"
              tabIndex={0}
              h="100%"
              border="1px solid"
              borderColor="rgba(255, 255, 255, 0.76)"
              borderRadius="xl"
              overflow="hidden"
              bg="rgba(255, 255, 255, 0.74)"
              boxShadow="sm"
              cursor="pointer"
              transition="transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease"
              _hover={{
                transform: "translateY(-3px)",
                boxShadow: "lg",
                borderColor: "primary.100",
              }}
              _focusVisible={{
                outline: "3px solid",
                outlineColor: "primary.100",
                outlineOffset: "3px",
              }}
              onClick={() => openVideo(src)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  openVideo(src);
                }
              }}
            >
              <CardBody p={0} display="flex" flexDirection="column" h="100%">
                <Box position="relative">
                  <AspectRatio ratio={16 / 9}>
                    {type === "youtube" ? (
                      <Image
                        src={`https://img.youtube.com/vi/${getVideoId(src)}/hqdefault.jpg`}
                        alt={title}
                        objectFit="cover"
                        w="100%"
                      />
                    ) : (
                      <Box as="video" w="100%" objectFit="cover" src={src} />
                    )}
                  </AspectRatio>
                  <Flex
                    position="absolute"
                    left="50%"
                    top="50%"
                    transform="translate(-50%, -50%)"
                    align="center"
                    justify="center"
                    w="44px"
                    h="44px"
                    borderRadius="full"
                    bg="rgba(255, 255, 255, 0.86)"
                    boxShadow="0 10px 24px rgba(37, 39, 45, 0.16)"
                    pointerEvents="none"
                  >
                    <Box
                      ml="3px"
                      w={0}
                      h={0}
                      borderTop="9px solid transparent"
                      borderBottom="9px solid transparent"
                      borderLeft="14px solid"
                      borderLeftColor="primary.500"
                    />
                  </Flex>
                </Box>
                <Flex direction="column" gap={2} p={{ base: 3, md: 4 }} flex="1">
                  <Badge
                    alignSelf="flex-start"
                    colorScheme="red"
                    variant="subtle"
                    borderRadius="full"
                    px={2}
                  >
                    YouTube
                  </Badge>
                  <Heading size="sm" lineHeight="1.35" noOfLines={2} minH="2.7em">
                    {title}
                  </Heading>
                  <Text
                    fontSize="sm"
                    color="rgba(0, 0, 0, 0.60)"
                    lineHeight="1.55"
                    noOfLines={2}
                    minH="3.1em"
                  >
                    {getPreviewText(detail)}
                  </Text>
                </Flex>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </Section>
    </>
  );
};

export default IntroVideo;
